export function getExtension(fileName) {
	let parts = fileName.split(".");
	return parts[parts.length - 1];
}

export async function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// sleep_cancelable(wait_time, obj, x = 10)
// wait_time: total ms to wait
// obj: { canceled: false }
// x: check interval ms (default 10)
export async function sleep_cancelable(wait_time, obj, x = 10) {
	    let elapsed = 0;
    while (elapsed < wait_time) {
        if (obj.canceled) {
            return true; // canceled
        }
        await new Promise(resolve => setTimeout(resolve, x));
        elapsed += x;
    }
    return obj.canceled; // false if not canceled
}


export function map_uint8(x, in_min, in_max, out_min, out_max) {
	const map_out = (x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
	let buf = new ArrayBuffer(1);
	let view = new DataView(buf);
	view.setUint8(0, map_out);
	return view.getUint8(0);
}